export const INTERNAL_USERS = [
  {'id': 0, 'user': 'AUTO_BIKE_SYNCHRONIZATION_USER', 'name': 'AUTO_BIKE_SYNCHRONIZATION_USER', 'display': 'SYSTEM'}
];
export const INTERNAL_USERS_BY_NAME = INTERNAL_USERS.reduce((acc, user) => {
  acc[user['name']] = user;
  return acc;
}, {});
